// Helper functions for generating Social Value by Age Group chart data

import { getFilteredReportData } from '../helpers/filterHelpers'
import { AGE_IMPACT } from '../fields'
import { ageFields, ageFieldLabels } from '../../../forms/stakeholdersFields'

// Generate chart data for age impact
const generateAgeImpactChartData = ageImpactData => {
  if (ageImpactData) {
    const labels = Object.values(ageFieldLabels)
    const data = Object.values(ageFields).map(field => ageImpactData[field]?.total || 0)

    return {
      labels: labels,
      datasets: [
        {
          label: 'Impact by Age Group',
          data: data,
          backgroundColor: '#D6AD68',
          borderRadius: 4,
          maxBarThickness: 55
        }
      ]
    }
  } else {
    return {
      labels: [],
      datasets: []
    }
  }
}

// Main function to generate chart data
export const generateSocialValueByAgeGroupData = ({ selectedRegion, selectedStakeholder, report }) => {
  const ageImpactData = getFilteredReportData({
    report,
    selectedRegion,
    selectedStakeholder,
    fieldName: AGE_IMPACT
  })
  return generateAgeImpactChartData(ageImpactData)
}
